import BaseInstitutionEntity from "@/models/Shared/BaseInstitutionEntity";

export default class User extends BaseInstitutionEntity {
    firstName: string;
    lastName: string;
    email: string;
    phone: string;
    enabled: boolean;
    deleted: boolean;
}